import React from 'react';
import PropTypes from 'prop-types';

import { t } from 'ttag';

import { mergeClasses } from '@utils';

import Card from './assets/GiftCard.png';

export default function GiftCard({ className = '', href = '#', ...restProps }) {
  return (
    <a
      className={mergeClasses(
        'flex flex-col justify-between rounded-xl bg-gradient-to-br from-green-700 to-green-400 px-6 pb-10 pt-6 text-white',
        className
      )}
      href={href}
      {...restProps}
    >
      <div>
        <span className="text-[24px] font-black uppercase leading-none">{t`Give a Gift Card`}</span>
        <span className="flex items-center gap-2 font-bold">
          {t`Buy now`}

          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className='"h-4 w-4 shrink-0'
            fill="currentColor"
          >
            <path d="M16.1716 10.9999L10.8076 5.63589L12.2218 4.22168L20 11.9999L12.2218 19.778L10.8076 18.3638L16.1716 12.9999H4V10.9999H16.1716Z" />
          </svg>
        </span>
      </div>
      <img
        src={Card}
        width={185}
        height={117}
        className="w-24 origin-center rotate-[25deg] self-end shadow-lg"
        alt=""
      />
    </a>
  );
}

GiftCard.propTypes = {
  className: PropTypes.string
};

GiftCard.defaultProps = {
  className: ''
};
